
<template>
  <div>
    <v-main class="login_background">
      <card-login card_color='white' logo_class='black'  title="Confirme seu e-mail">
        <template v-slot:form>
          <span class="title d-flex justify-center">
            Formulário enviado com sucesso! 
            <br class="mt-5"> Logo a empresa irá retornar o seu contato para mais detalhes. 
            <br class="mt-5"> Até breve!
          </span>
        </template>
      </card-login>
    </v-main>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ConfirmNegotiationSended',
  components: {
    CardLogin: () => import("@/_auth/components/containers/_auth_card_01.vue"),
  },
}
</script>

<style scoped>

.login_background {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), url('../../assets/login_background.png');
  /* background: url('../../assets/background_login.jpg') */
}

</style>